module.exports = __webpack_public_path__ + "img/circle-copy.edec130f.svg";